<template>
  <!-- Other HTML code for your page -->

  <button @click="logout">Logout</button>
</template>

<script>
import { getAuth, signOut } from 'firebase/auth';

export default {
  // Other component options...

  methods: {
    logout() {
      const auth = getAuth();
      signOut(auth).then(() => {
        // Sign-out successful, redirect to login page
        this.$router.push('/');
      }).catch((error) => {
        // An error occurred
        console.error('Error signing out: ', error);
      });
    }
  }
}
</script>

<style scoped>
.logout-button {
  position: fixed;
  left: 0;
  bottom: 0;
  margin: 20px;
  padding: 10px;
}
</style>